import { render, staticRenderFns } from "./SkupoviTeme2.vue?vue&type=template&id=9e47bd28&scoped=true&"
import script from "./SkupoviTeme2.vue?vue&type=script&lang=js&"
export * from "./SkupoviTeme2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e47bd28",
  null
  
)

export default component.exports